"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (key) {
    return {
        load: function load() {
            var jsonState = sessionStorage.getItem(key);
            return Promise.resolve(JSON.parse(jsonState) || {});
        },
        save: function save(state) {
            var jsonState = JSON.stringify(state);
            sessionStorage.setItem(key, jsonState);
            return Promise.resolve();
        }
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7a0JBQWUsVUFBQyxHQUFEO1dBQVU7QUFDckIsOEJBQU87QUFDSCxnQkFBTSxZQUFZLGVBQWUsT0FBZixDQUF1QixHQUF2QixDQUFaLENBREg7QUFFSCxtQkFBTyxRQUFRLE9BQVIsQ0FBZ0IsS0FBSyxLQUFMLENBQVcsU0FBWCxLQUF5QixFQUF6QixDQUF2QixDQUZHO1NBRGM7QUFNckIsNEJBQUssT0FBTztBQUNSLGdCQUFNLFlBQVksS0FBSyxTQUFMLENBQWUsS0FBZixDQUFaLENBREU7QUFFUiwyQkFBZSxPQUFmLENBQXVCLEdBQXZCLEVBQTRCLFNBQTVCLEVBRlE7QUFHUixtQkFBTyxRQUFRLE9BQVIsRUFBUCxDQUhRO1NBTlM7O0NBQVYiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCAoa2V5KSA9PiAoe1xuICAgIGxvYWQoKSB7XG4gICAgICAgIGNvbnN0IGpzb25TdGF0ZSA9IHNlc3Npb25TdG9yYWdlLmdldEl0ZW0oa2V5KTtcbiAgICAgICAgcmV0dXJuIFByb21pc2UucmVzb2x2ZShKU09OLnBhcnNlKGpzb25TdGF0ZSkgfHwge30pO1xuICAgIH0sXG5cbiAgICBzYXZlKHN0YXRlKSB7XG4gICAgICAgIGNvbnN0IGpzb25TdGF0ZSA9IEpTT04uc3RyaW5naWZ5KHN0YXRlKTtcbiAgICAgICAgc2Vzc2lvblN0b3JhZ2Uuc2V0SXRlbShrZXksIGpzb25TdGF0ZSk7XG4gICAgICAgIHJldHVybiBQcm9taXNlLnJlc29sdmUoKTtcbiAgICB9XG59KTtcbiJdfQ==